<template lang="html">
    <div class="lessonProTimePicker">
        <button
            v-if="!timePickerOpen"
            @click.prevent="openTime"
            class="button dark alignLeft"
            type="button"
            name="button"
            :class="{ complete: inputVal.length > 0 }"
        >
            {{ selectedTime ? selectedTime : "Select time" }}
            <img class="arrow" src="~@/assets/arrow-right-white-2.svg" />
        </button>

        <div class="" v-else>
            <ul class="times">
                <li
                    :class="{ active: inputVal.includes(time) }"
                    v-for="(time, index) in times"
                    :key="index"
                    @click.prevent="selectTime(time)"
                >
                    {{ $date("2020-12-08 " + time.start).format("HH:mm") }} -
                    {{ $date("2020-12-08 " + time.end).format("HH:mm") }} <span></span>
                </li>
            </ul>

            <button
                @click.prevent="closeTimePicker"
                v-if="inputVal.length > 0"
                class="button green"
                type="button"
                name="button"
            >
                Add time
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "lesson-pro-time-picker",
    props: {
        times: {
            type: Array,
            required: false,
        },
        timePickerOpen: {
            type: Boolean,
            required: true,
        },
        value: {},
    },
    computed: {
        selectedTime() {
            if (this.inputVal.length == 0) {
                return false;
            }
            var times = "";
            this.inputVal.forEach((time) => {
                times +=
                    this.$date("2020-12-08 " + time.start).format("HH:mm") +
                    " - " +
                    this.$date("2020-12-08 " + time.end).format("HH:mm") +
                    ", ";
            });
            return times.slice(0, -2);
        },
        inputVal: {
            get() {
                return this.value;
            },
            set(time) {
                // Check to see if array item exists. If it does remove else add
                //  this.inputVal = time;

                this.inputVal.splice(0, 1, time);

                this.$emit("input", this.inputVal);
            },
        },
    },
    methods: {
        closeTimePicker() {
            this.$emit("timePickerClosed");
        },
        openTimePicker() {
            this.$emit("timePickerOpen");
        },
        selectTime(time) {
            this.inputVal = time;
        },
        openTime() {
            if (this.times.length == 0) {
                this.$notify({
                    type: "error",
                    text: "Please choose a date to see the time times for it.",
                });
            } else {
                this.openTimePicker();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.lessonProTimePicker {
    margin-bottom: 10px;
    .button {
        margin-bottom: 10px;
        &.complete {
            background: white;
            color: $green_0;
        }
    }

    .arrow {
        position: absolute;
        right: 20px;
        top: 20px;
    }
    .times {
        background: white;
        border-radius: $radius;
        padding: 10px 20px;
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);
        margin-bottom: 10px;
        &:after {
            content: "";
            display: block;
            clear: both;
        }
        li {
            padding-top: 15px;
            padding-bottom: 15px;
            width: 50%;
            float: left;
            position: relative;
            &.active {
                color: $green_1;
                position: relative;
                span:after {
                    content: "";
                    width: 13px;
                    height: 13px;
                    background: $green_1;
                    display: block;
                    position: absolute;
                    border-radius: 3px;
                    top: 4px;
                    left: 4px;
                }
            }

            span {
                position: absolute;
                right: 20px;
                top: 12px;
                background: $grey;
                display: inline-block;
                width: 20px;
                height: 20px;
                border-radius: 3px;
            }
        }
    }
}
</style>
